

export function getWx () {
    if(typeof(wx) !== "undefined") {
        return wx
    } else {
        return undefined
    }
}